<template lang="pug">
div.body-lo
  div.modal-header
    span.lo-modal-title(v-if="item && item !== null") SỬA TÊN KÊNH
    span.lo-modal-title(v-else) THÊM KÊNH
    span.lo-modal-btn-close.material-icons(@click="closePopup") close
  div.modal-body
    .reg-content
      .form-group(v-bind:class="[isSubmitFinish && (key_name.length === 0 || (key_name.length > 0 && key_exists))? 'error' : '']")
        label.control-label(v-if="item && item !== null") Tên kênh
        label.control-label(v-else) Nhập tên kênh
        input.form-control(name="key_name" placeholder="Nhập tên kênh muốn thêm" v-model.trim="key_name" @keyup="onChange" maxlength=125)
        span.required(v-if="key_name.length === 0") Vui lòng nhập tên kênh
        span.required(v-if="isSubmitFinish && key_name.length > 0 && key_exists") Tên kênh đã tồn tại
  div.modal-footer.lo-custom-footer
    div.row
      div.col-md-12.col-12.text-center.popup-button
        button.btn-active.btn-popup(@click="submitChannel" v-if="item && item !== null") Lưu thay đổi
        button.btn-active.btn-popup(@click="submitChannel" v-else) Thêm mới
        button.btn-popup(@click="closePopup") Huỷ yêu cầu
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
export default {
  props: {
    item: Object,
    classes_id: Number,
    saveChannel: Function
  },
  data() {
    return {
      isSubmitFinish: false,
      key_exists: false,
      key_name: (this.item && this.item !== null) ? this.item.name : ''
    }
  },
  methods: {
    closePopup() {
      this.$emit('close')
    },
    async submitChannel() {
      this.isSubmitFinish = false
      if (this.key_name.length === 0) {
        this.isSubmitFinish = true
      } else {
        this.isSubmitFinish = true
        await this.checkExists()
        if (!this.key_exists) {
          this.saveChannel({dataInput: {item: this.item, name: this.key_name}})
          this.$nextTick(() => {
            this.$emit('close')
          })
        }
      }
    },
    async checkExists () {
      var objWhere = {
        classes_id: {_eq: Number(this.classes_id)},
        is_delete: {_eq: false}
      }
      objWhere = Object.assign(objWhere, {name: {_ilike: this.key_name}})
      if (this.item && this.item !== null && !isNaN(this.item.id) && Number(this.item.id) > 0) {
        objWhere = Object.assign(objWhere, {id: {_neq: Number(this.item.id)}})
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_CHANNEL),
        fetchPolicy: 'no-cache',
        variables: {
          where: objWhere
        }
      })
      this.key_exists = data.channel.length > 0
    },
    onChange(e) {
      if (this.key_name.trim().length >= 0) {
        this.error = ''
        if (e.keyCode === 13) this.submitChannel()
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-lo {
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  .lo-modal-title {
    font-family: 'adobe-clean', sans-serif;
    float: left;
    font-size: 17px;
  }
  .lo-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .note{margin-bottom: 15px;
    span{font-weight: bold;}
  }
  .reg-content{
    .form-group{position: relative; margin-top: 10px; padding-bottom: 0;
      input, select{background: #fff; border-radius: 10px;}
      &.error{
        input, select{border: 1px solid #f00;color: #f00;}
        span.required{display: block; color: #f00; text-align: left; font-weight: normal;}
      }
      label{font-size: 15px;color: #333;margin-bottom: 15px;display: block;}
      span.required{display: none;}
    }
  }
  .popup-button{text-align: center; margin-top: 25px; margin-bottom: 15px;
    .btn-popup{border-radius: 5px; height: 48px; font-size: 14px;background: #fff; border: 1px solid #FFD311; color: #23180A; margin: 0;width: 160px;
      &.btn-active{background: #FFD311 0% 0% no-repeat padding-box; border: 1px solid #FFD311; margin-right: 30px;}
    }
  }
  .lo-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .lo-btn-continue {
    background: var(--color-background-button);
    color: #000;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 15px;
  }
  .lo-popup-pc{color: #23180A; font-size: 14px;}
  .lo-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .lo-custom-footer {
    padding: 0;
    border: 0;
  }
// cellphones 
@media (max-width: 414px) {
  .lo-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
  }
  .lo-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
  }
}
}
</style>



// WEBPACK FOOTER //
// popup.vue?108492fa